module.exports = __webpack_public_path__ + "3680fc60947d080a62c76a55cafc43b9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-info.svg
// module id = MZQ5
// module chunks = 5